var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./~/_can-use-dom@0.1.0@can-use-dom/index.js
// module id = 391
// module chunks = 0 1